import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    content: {
      '& .MuiTable-root': {
        '& .MuiTableCell-root:first-child': {
          paddingLeft: 16,
        },
      },
      '& th.MuiTableCell-root': {
        padding: '0px 8px',
      },

      '& td.MuiTableCell-root': {
        padding: '0px 8px',
      },
    },

    closeLogs: {
      margin: '16px 0 8px',
    },
    longField: {
      maxWidth: 120,
      '& .MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 12,
        color: palette.darkGray,
        cursor: 'pointer',
        width: '90%',
      },
    },
    longNameField: {
      maxWidth: 240,
    },
    numberField: {
      textAlign: 'center',
      fontSize: 12,
      color: palette.darkGray,
      cursor: 'pointer',
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    listGrid: {
      paddingLeft: 10,
    },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    dateField: {
      fontSize: 12,
      whiteSpace: 'nowrap',
    },
    tableLine: {
      fontSize: 12,
      cursor: 'pointer',
      color: palette.darkGray,
    },
    textAndIcon: {
      color: palette.darkGray,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      marginRight: 10,

      '& svg': {
        fontSize: 15,
      },
    },
    summaryRowTable: {
      backgroundColor: `${palette.white} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: '0px 16px',
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
    envRow: {
      backgroundColor: `${palette.lightYellow} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: '0px 16px',
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
    cardsTitle: {
      fontSize: 14,
      color: palette.darkGray,
      marginBottom: 4,
      fontWeight: 550,
    },
    cardsTitleModal: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 550,
    },
    cardGrid: { marginTop: 6 },
    statusModalGrid: { marginBottom: 16 },
    dashboardButtonsHeader: {
      color: palette.blue,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    dashboardButtonsHeaderConfig: {
      color: palette.blue,
      padding: '4px 8px!important',
      marginLeft: 16,
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    dashboardHeader: { marginTop: 16 },
    switchText: { fontSize: 12, fontWeight: 500, marginLeft: 2 },
    switchGrid: { alignItems: 'center', display: 'flex', marginRight: '8px' },
    switchGridContainer: { marginBottom: 16 },
    previewModal: { display: 'flex', justifyContent: 'center' },
    cardPreview: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      width: 'max-content',
    },
    cardPreviewItem: {
      margin: 6,
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      padding: 8,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    closeIcon: {
      color: palette.red,
      fontSize: 20,
      cursor: 'pointer',
      marginRight: 2,
    },
    dragIcon: {
      color: palette.blue,
      fontSize: 20,
      cursor: 'grab',
      marginLeft: 2,
    },
    cardPreviewNoDash: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      padding: 8,
      alignItems: 'center',
    },
    noDashIcon: {
      color: palette.grey600,
      fontSize: 18,
      marginRight: 4,
    },
    optionsModal: { display: 'flex', justifyContent: 'flex-end' },
    cleanIcon: { color: palette.red, fontSize: 26, cursor: 'pointer' },
    cleanButton: {
      color: palette.red,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
    cardSelector: {
      margin: 6,
      maxWidth: '32%',
      width: '32%',
      cursor: 'pointer',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
    },
    cardSelectorActive: {
      border: `1px solid ${palette.green}`,
      margin: 6,
      borderRadius: 4,
      maxWidth: '32%',
      width: '32%',
      backgroundColor: palette.lightGreen,
    },
    modalCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 4,
    },
    checkIconModal: { fontSize: 20, color: palette.green },
    modalCardHeaderCollapse: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 0,
    },
  });
